import {
  SETTING_LIST_INITING,
  SETTING_LIST_REQUESTING,
  SETTING_LIST_SUCCESS,
  SETTING_LIST_ERROR,
  SETTING_UPDATE_STORE_REQUESTING,
  SETTING_UPDATE_STORE_SUCCESS,
  SETTING_UPDATE_STORE_ERROR,
} from './constants'

const initialState = {
  list: [],
  item: {},
  type: SETTING_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function settingReducer (state = initialState, action) {
  switch (action.type) {
    case SETTING_LIST_REQUESTING:
      return {
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [],
        errors: [],
      }

    case SETTING_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case SETTING_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

      case SETTING_UPDATE_STORE_REQUESTING:
        return {
          list: [],
          type: action.type,
          listRequesting: true,
          requesting: false,
          successful: false,
          messages: [],
          errors: [],
        }

      case SETTING_UPDATE_STORE_SUCCESS:
        return {
          ...state, // ensure that we don't erase fetched ones
          list: [],
          item: action.data,
          type: action.type,
          listRequesting: false,
          requesting: false,
          successful: true,
          messages: [{
            body: 'Cập nhật thành công',
            time: new Date(),
          }],
          errors: [],
        }

      case SETTING_UPDATE_STORE_ERROR:
        return {
          ...state, // ensure that we don't erase fetched ones
          list: [],
          item: {},
          type: action.type,
          listRequesting: false,
          requesting: false,
          successful: false,
          messages: [],
          errors: [{
            body: action.error.toString(),
            time: new Date(),
          }],
        }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Setting/reducer.js